import {Grid} from "@mui/material";
import React from "react";
import {
  minValue,
  number,
  ReferenceInput,
  required,
  AutocompleteInput,
  SelectInput
} from "react-admin";
import { PriceInput } from "src/components/input/PriceInput";
import { CurrencyEnum } from "src/common/enum/CurrencyEnum";
import { RbacWrapperForm} from "src/components/common/RbacWrapperForm";

export const PriceForm = () => {
  const validatePrice = [required(), number(), minValue(0)];

  return (
    <RbacWrapperForm>
      <Grid container item sm={12} md={6} rowSpacing={1} columnSpacing={2}>
        <Grid item sm={12} md={6}>
          <SelectInput
            source="price.currency"
            label="Currency"
            choices={CurrencyEnum}
            defaultValue={'EUR'}
            validate={required()}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <PriceInput
            source="price.price"
            label="Price"
            format={(v) => String(v / 100)}
            parse={(v) => parseFloat(v) * 100}
            currencyField="price.currency"
            validate={validatePrice}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <SelectInput
            source="price.manufacturer_currency"
            label="Manufacturer Currency"
            choices={CurrencyEnum}
            defaultValue={'EUR'}
            validate={required()}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <PriceInput
            source="price.manufacturer_price"
            label="Manufacturer Price"
            format={(v) => String(v / 100)}
            parse={(v) => parseFloat(v) * 100}
            currencyField="price.manufacturer_currency"
            validate={validatePrice}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <PriceInput
            source="price.sales_price"
            label="Sales Price"
            format={(v) => String(v / 100)}
            parse={(v) => parseFloat(v) * 100}
            currencyField="price.currency"
            validate={validatePrice}
          />
        </Grid>
      </Grid>
      <Grid container item sm={12} md={6} rowSpacing={1} columnSpacing={2}>
        <Grid item sm={12} md={6}>
          <ReferenceInput
            source="price.tax_class.id"
            reference="admin/taxes"
            perPage={50}
          >
            <AutocompleteInput
              optionText="name"
              label="Tax Class"
              size="small"
              defaultValue=""
            />
          </ReferenceInput>
        </Grid>
        <Grid item sm={12} md={6}>
          <ReferenceInput
            source="price.price_calculator.id"
            reference="admin/product/price-calculators"
            perPage={50}
          >
            <AutocompleteInput
              optionText="name"
              label="Price Calculator"
              size="small"
              defaultValue=""
            />
          </ReferenceInput>
        </Grid>
      </Grid>
    </RbacWrapperForm>
  );
};
